import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Fragment, ReactElement, useState } from "react";

export type ExpandableCardProps = {
  caption: string;
  headerButtons?: ReactElement[];
  allowExpand?: boolean;
  expanded?: boolean;
  children: React.ReactNode;
};

export function ExpandableCard({ allowExpand = true, ...props }: ExpandableCardProps) {
  const [expanded, setExpanded] = useState<boolean>(props.expanded ?? false);

  function toggleExpanded(e: React.MouseEvent) {
    if (allowExpand) {
      e.stopPropagation();
      setExpanded((prev) => !prev);
    }
  }

  return (
    <div className={`card ${!expanded && "border-bottom-0"}`}>
      <div
        className={`card-header d-flex justify-content-between ${allowExpand && `cursor-pointer`}`}
        onClick={toggleExpanded}
      >
        <div className="d-flex gap-2">
          {props.caption}
          {props.headerButtons?.map((button, index) => (
            <Fragment key={index}>{button}</Fragment>
          ))}
        </div>
        {allowExpand && (
          <FontAwesomeIcon
            role="button"
            icon={expanded ? faChevronUp : faChevronDown}
            size="sm"
            className="ms-2 my-auto"
            title={expanded ? "Collapse" : "Expand"}
            onClick={toggleExpanded}
            fixedWidth={true}
          />
        )}
      </div>
      {expanded && <div className="card-body pe-2">{props.children}</div>}
    </div>
  );
}
